import React from "react";
import PrimaryButton from "../../common/Button/PrimaryButton";

type FeatureHighlightProps = {
  heading: string;
  subheading: string;
  buttonText: string;
  buttonOnClick: () => void;
  isVideo: boolean;
  assetSrc: string;
  assetPosition: "left" | "right";
};

type TextContentProps = {
  heading: string;
  subheading: string;
  buttonText: string;
  buttonOnClick: () => void;
};

const FeatureHighlight = ({
  heading,
  subheading,
  buttonText,
  buttonOnClick,
  isVideo,
  assetSrc,
  assetPosition,
}: FeatureHighlightProps) => {
  return (
    <div>
      <div className="lg:block hidden">
        <div className="flex gap-12 items-center justify-center text-black py-[40px]">
          {assetPosition === "left" ? (
            <AssetContent isVideo={isVideo} assetSrc={assetSrc} />
          ) : (
            <TextContent
              heading={heading}
              subheading={subheading}
              buttonText={buttonText}
              buttonOnClick={buttonOnClick}
            />
          )}
          {assetPosition === "left" ? (
            <TextContent
              heading={heading}
              subheading={subheading}
              buttonText={buttonText}
              buttonOnClick={buttonOnClick}
            />
          ) : (
            <AssetContent isVideo={isVideo} assetSrc={assetSrc} />
          )}
        </div>
      </div>

      <div className="block lg:hidden px-8 text-black py-[40px]">
        <AssetContent isVideo={isVideo} assetSrc={assetSrc} />
        <div className="p-6"></div>
        <TextContent
          heading={heading}
          subheading={subheading}
          buttonText={buttonText}
          buttonOnClick={buttonOnClick}
        />
      </div>
    </div>
  );
};

const TextContent = ({
  heading,
  subheading,
  buttonText,
  buttonOnClick,
}: TextContentProps) => {
  return (
    <div className="lg:max-w-md">
      <h2 className="font-bold text-3xl lg:w-full lg:text-4xl leading-10">
        {heading}
      </h2>
      <p className="pt-6">{subheading}</p>
      <div className="pt-6">
        <PrimaryButton className="rounded-md" text={buttonText} />
      </div>
    </div>
  );
};

const AssetContent = ({
  isVideo,
  assetSrc,
}: {
  isVideo: boolean;
  assetSrc: string;
}) => {
  return (
    <div className="md:flex md:justify-center">
      {isVideo ? (
        <video
          autoPlay
          muted
          loop
          playsInline
          className="rounded-md w-full object-cover md:w-[450px] h-[480px]"
          src={assetSrc}
        ></video>
      ) : (
        <img src={assetSrc}></img>
      )}
    </div>
  );
};

export default FeatureHighlight;
